/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sdDownloadAttachment, sdFormatBytes, sdGetAttachmentIcon, sdShowToast, sdTimeAgoFromUTCTimestamp, sdUTCTimestampStrToLocalStr, sdUTCTimestampToFriendlyDateAndTimeAgo } from 'helpers/sdHelper';
import React, { useState } from 'react';
import { Tab, Tabs, Card, Form, Button, Table } from 'react-bootstrap';
import { sdAddCommentToIssue } from 'services/service-desk/sdService';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import IconButton from 'components/common/IconButton';
import SDUserBadge from '../SDUserBadge';
import SDEditor from '../SDEditor';

const SDIssueActivity = ({ issue, onCommentAdded }) => {
    const [newComment, setNewComment] = useState('');

    const [newCommentDisabled, setNewCommentDisabled] = useState(true);
    const [activeNewCommentTab, setActiveNewCommentTab] = useState(null);
    const handleNewCommentTabSelect = (key) => {
        setActiveNewCommentTab(key);
        console.log('Selected tab:', key); // You can use this in JS
        setNewCommentDisabled(false);
    };

    const isReplyingToCustomer = () => {
        return activeNewCommentTab === 'tbReplyToCustomer';
    }

    function addComment() {
        if (!newComment || newComment.length == 0) return;
        sdAddCommentToIssue(issue.id, newComment, 'text/html', isReplyingToCustomer()).then(res => {
            sdShowToast("Added comment!", false);
            setNewComment('');
            onCommentAdded();
        }).catch(err => {
            sdShowToast(`Failed to add comment to issue (${err.response.status})`, true);
            console.error(err);
        });
    }

    if (issue == null) {
        return <></>
    }

    let commentTabTitle = 'Comments'
    let attachmentTabTitle = 'Attachments'
    let activityTabTitle = 'Activity'

    if (issue.comments && issue.comments.length > 0) {
        commentTabTitle = commentTabTitle + ` (${issue.comments.length})`;
    }

    if (issue.attachments && issue.attachments.length > 0) {
        attachmentTabTitle = attachmentTabTitle + ` (${issue.attachments.length})`;
    }

    if (issue.activities && issue.activities.length > 0) {
        activityTabTitle = activityTabTitle + ` (${issue.activities.length})`;
    }

    return (
        <Card>
            {/* <Card.Header className="bg-light btn-reveal-trigger d-flex flex-between-center">
                <h5 className="mb-0">Order Summary</h5>
                <Link
                    to="/e-commerce/shopping-cart"
                    className="btn btn-link btn-sm btn-reveal text-600"
                >
                    <FontAwesomeIcon icon="pencil-alt" />
                </Link>
            </Card.Header> */}
            <Card.Body className='p-0'>
                <Tabs defaultActiveKey="comments" id="uncontrolled-tab-example">
                    <Tab eventKey="comments" title={commentTabTitle} className='border-bottom border-x p-0'>
                        <>

                            <Form.Group className="mb-0 p-3" controlId="exampleForm.ControlTextarea1">
                                <Tabs defaultActiveKey="comments" onSelect={handleNewCommentTabSelect}>
                                    <Tab eventKey="tbAddInternalNote" title="Add internal note" className='border-bottom border-x p-0'></Tab>
                                    <Tab eventKey="tbReplyToCustomer" title="Reply to customer" className='border-bottom border-x p-0'></Tab>
                                </Tabs>
                                {/* <Form.Control as="textarea" rows={3} value={newComment} onChange={(e) => { setNewComment(event.target.value) }} /> */}
                                <fieldset disabled><SDEditor value={newComment} onChange={(val) => { setNewComment(val) }} disabled={newCommentDisabled}></SDEditor></fieldset>
                                <div className="d-flex justify-content-end mt-1">
                                    <IconButton variant={isReplyingToCustomer() ? 'primary' : 'secondary'} 
                                    icon={isReplyingToCustomer() ? 'envelope' : 'comments'}  type="submit" className="mt-0" size="sm" onClick={() => addComment()}>
                                        {isReplyingToCustomer() ? 'Reply To Customer' : 'Add Internal Note'}
                                    </IconButton>
                                </div>
                            </Form.Group>

                            <div className='p-3'>
                                {issue.comments.map((comment, index) => (
                                    // <Container key={comment.id}>
                                    //     <b>{comment.author.displayName}</b><span className='text-muted text-end' style={{ textAlign: 'right' }}>{dayjs(comment.created).format('dddd, MMMM D, YYYY h:mm A')}</span><br></br>

                                    //     {comment.content}
                                    //     <br></br>
                                    //     <br></br>
                                    // </Container>

                                    <div key={comment.id}>
                                        <Flex className="mt-3">
                                            <Avatar size="xl" name={comment.author.displayName} />
                                            <div className="flex-1 ms-2 fs--1">
                                                <a href="#" className="fw-semi-bold">
                                                    {comment.author.displayName}&nbsp;&nbsp;
                                                </a>
                                                <SDUserBadge user={comment.author}></SDUserBadge>

                                                <div className="mb-1 bg-200 rounded-3 p-2">

                                                    {comment.contentType === 'text/html' ? <div dangerouslySetInnerHTML={{ __html: comment.content }}>

                                                    </div> :
                                                        <div
                                                            className="ms-1"
                                                        >{comment.content}</div>}
                                                </div>
                                                <div className="px-2">
                                                    📅{sdUTCTimestampStrToLocalStr(comment.created)} ({sdTimeAgoFromUTCTimestamp(comment.created)})
                                                    {comment.emailAttachmentId && comment.emailAttachmentId > 0 ?
                                                        <span>&nbsp;| <a href="#" onClick={() => { sdDownloadAttachment(comment.emailAttachmentId) }}>Download original message</a></span>
                                                        : <></>}
                                                    <span className='justify-content-end text-end'>&nbsp;|&nbsp;{comment.external == false ? '🔒 Internal Comment' : '🌍 Public Comment'}</span>
                                                </div>
                                            </div>
                                        </Flex>
                                    </div>
                                ))}
                            </div>


                        </>

                    </Tab>
                    <Tab eventKey="attachments" title={attachmentTabTitle} className='border-bottom border-x p-3'>

                        {issue.attachments && issue.attachments.length > 0 ?
                            <>
                                <Table>
                                    <tbody>{issue.attachments.map((attachment, index) => (<SDAttachment key={attachment.id} attachment={attachment}></SDAttachment>
                                    ))}</tbody>
                                </Table>

                            </> :
                            <p>
                                <i>No attachments exist for this issue</i>
                            </p>
                        }
                    </Tab>
                    <Tab eventKey="activity" title={activityTabTitle} className='border-bottom border-x p-3'>
                        {issue.activities && issue.activities.length > 0 ?
                            <>
                                {issue.activities.map((activity, index) => (<SDActivity key={activity.id} activity={activity}></SDActivity>
                                ))}
                            </> :
                            <p>
                                <i>No activities exist for this issue</i>
                            </p>
                        }
                    </Tab>
                </Tabs>
            </Card.Body>
            {/* <Card.Footer className="d-flex justify-content-between bg-light">
                <div className="fw-semi-bold">Payable Total</div>
                <div className="fw-bold">$0.0</div>
            </Card.Footer> */}
        </Card>);
}

const SDAttachment = ({ attachment }) => {
    return (
        <tr>
            <td className=''><FontAwesomeIcon icon={sdGetAttachmentIcon(attachment.extension)} className="fs-4" /></td>
            <td className=''>{attachment.name}</td>
            <td className='align-middle'>{attachment.author.displayName}</td>
            <td className='align-middle'>{sdUTCTimestampStrToLocalStr(attachment.created)} ({sdTimeAgoFromUTCTimestamp(attachment.created)})</td>
            <td className='align-middle'>{sdFormatBytes(attachment.size)}</td>
            <td className='align-middle text-end'><IconButton
                className="me-2 mb-1"
                variant="falcon-default"
                size="sm"
                icon="faDownload"
                transform="shrink-3"
                onClick={() => sdDownloadAttachment(attachment.id)}
            >
                Download
            </IconButton></td>
        </tr>
    );
};

const SDActivity = ({ activity }) => {
    let avatar = <Avatar emoji="⚙️"></Avatar>
    let name = "System"
    if (activity.changedByUser) {
        avatar = <Avatar name={activity.changedByUser.displayName}></Avatar>
        name = activity.changedByUser.displayName;
    }
    return (
        <Flex className="mt-3" key={activity.id} >
            {avatar}
            <div className="flex-1 ms-2 fs--1" key={activity.id}>
                <a href="#?" className="fw-semi-bold mr-2">
                    {name}&nbsp;&nbsp;
                </a>
                <SDUserBadge user={activity.changedByUser}></SDUserBadge>
                <p className="mb-1 bg-200 rounded-3 p-2">
                    {activity.message}
                    {(activity.fieldName && activity.fieldOldValue && activity.fieldNewValue) ? <br></br> : <></>}
                    {(activity.fieldName && activity.fieldOldValue && activity.fieldNewValue) ? <span>{activity.fieldOldValue} &rarr; {activity.fieldNewValue}</span> : <></>}
                </p>
                {/* <div
                    className=""
                >{(activity.fieldName && activity.fieldOldValue && activity.fieldNewValue) ? <span>'{activity.fieldOldValue}' &rarr; '{activity.fieldNewValue}'</span> : <></>}</div> */}

                <div className="px-2">
                    {sdUTCTimestampToFriendlyDateAndTimeAgo(activity.timestamp)}
                </div>
            </div>
        </Flex>
    )
}
export default SDIssueActivity;